import WidgetMetricDisplay from "@/components/common/WidgetMetricDisplay";
import PhoneInOutIcon from "@/components/icons/PhoneInOutIcon";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import React from "react";

interface TotalTransferredCallsWidgetProps {
  data: { value: number; comparisonPercentage?: number; callMicrosoftIds?: string[] };
  icon?: React.ReactNode;
  loading?: boolean;
  error?: string;
  onClick?: (filters: { [key: string]: string[] }, callMicrosoftIds?: string[]) => void;
}

const TotalTransferredCallsWidget: React.FC<TotalTransferredCallsWidgetProps> = ({ data, loading, onClick }) => {
  const canClick = onClick && data.value > 0;
  const { callMicrosoftIds } = data;

  const handleClick = () => {
    if (canClick) {
      const filters: { [key: string]: string[] } = { callStatus: ["Transferred"] };
      onClick(filters, callMicrosoftIds && callMicrosoftIds.length > 0 ? callMicrosoftIds : undefined);
    }
  };

  return (
    <div
      className={`w-full min-w-[200px] rounded-lg border flex flex-col bg-white dark:bg-[#0C3451] dark:text-white dark:border-[#3C5C73] p-3 transition-colors ${canClick ? 'hover:bg-gray-50 dark:hover:bg-[#1a4a66] cursor-pointer' : ''}`}
      onClick={handleClick}
    >
      <div className="flex flex-row items-center justify-between">
        <div className="text-[14px] font-[600] text-teamscx-primary dark:text-white truncate">Total Transferred Calls</div>
        <TooltipProvider>
          <Tooltip delayDuration={0}>
            <TooltipTrigger asChild>
              <span className="cursor-pointer">
                <PhoneInOutIcon className="h-4 w-4 text-primary dark:text-white" />
              </span>
            </TooltipTrigger>
            <TooltipContent side="top">
              <p className="max-w-xs text-xs">The total number of calls that transferred (transferred from an agent to a call queue and transferred to another agent) within the given time.</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <div>
        <WidgetMetricDisplay
          value={data.value}
          comparisonPercentage={data.comparisonPercentage}
          invertColors={true}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default TotalTransferredCallsWidget;
